import { ReactKeycloakProvider } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import keycloak from './config/keycloak';
import AppRouter from './AppRouter';
import { $user } from 'models/user';
import { KeycloakTokenParsed } from 'keycloak-js';
import { useUnit } from 'effector-react';
import toast from 'react-hot-toast';
import { ModalContextProvider } from './providers/modalProvider';

const eventLogger = async (event: unknown, error: unknown) => {
  if (event === 'onTokenExpired') {
    try {
      const refreshed = await keycloak.updateToken(30);

      if (!refreshed) {
        keycloak.logout();
      }
    } catch (e) {
      console.error('Ошибка при обновлении токена:', e);
      keycloak.logout();
    }
  }

  if (error) {
    toast.error(`Ошибка: ${error}`);
  }
};

const LoadingComponent = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="text-xl text-gray-600">Подключение к Keycloak...</div>
  </div>
);

const App = () => {
  const user = useUnit($user);
  const navigate = useNavigate();

  const tokenLogger = () => {
    const tokenParsed: KeycloakTokenParsed = keycloak.tokenParsed!;

    if (tokenParsed && user && tokenParsed?.groups?.length !== user?.groups?.length) {
      const encodedRef = encodeURIComponent(location.pathname);
      navigate(`/login?ref=${encodedRef}`);
    }
  };

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={eventLogger}
      onTokens={tokenLogger}
      LoadingComponent={<LoadingComponent />}
    >
      <ModalContextProvider>
        <AppRouter />
      </ModalContextProvider>
    </ReactKeycloakProvider>
  );
};

export default App;
